import React, { Component } from 'react'

import AppSettingsSidebarComponent from './parts/sidebar'
import AppSettingsContentComponent from './parts/content'

class AppSettingsComponent extends Component {
    render() {
        return (
            <div>
				<h2>Instellingen</h2>
				<div className="grid-x grid-padding-y">
					<AppSettingsSidebarComponent />
					<AppSettingsContentComponent />
				</div>
			</div>
        )
    }
}

export default AppSettingsComponent;


// WEBPACK FOOTER //
// ./src/application/components/settings/index.js